import {
  formSolicitacao,
  documentacaoPorTipoSolicitacao,
  documentosPorRegra,
  possuiSolicitacaoEmAndamento,
  recaptcha,
  possuiAutorizacaoConsumidorCativo,
  solicitacaoPreAprovada,
} from './states/solicitacao';
import { tipoAgente } from './states/tipoAgente';

const state = () => ({
  tipoAgente,
  formSolicitacao,
  documentacaoPorTipoSolicitacao,
  documentosPorRegra,
  possuiSolicitacaoEmAndamento,
  recaptcha,
  possuiAutorizacaoConsumidorCativo,
  solicitacaoPreAprovada,
});

export default state;
